import Menu from './Menu';
import SubMenu from './SubMenu';
import MenuItem from './MenuItem';
import MenuItemGroup from './MenuItemGroup';

Menu.SubMenu = SubMenu;
Menu.Item = MenuItem;
Menu.ItemGroup = MenuItemGroup;

export default Menu;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/menu/index.js
// module id = 402
// module chunks = 0